unable to read source [project]/node_modules/src/html5-qrcode-scanner.ts